/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.js" />
/// <reference path="skyward.ui.codeeel.ts" />
(
    function (skyward, $, undefined)
    {
        skyward.health = skyward.health || {};

        //Immunization Status
        var loadAnnualImmunizationStatusTable = function ()
        {
            var tableContainer = $(this);
            var calculationDate = tableContainer.find('#CalculationDate');

            calculationDate.change(function ()
            {
                var dateValue = skyward.controls.getValue(calculationDate);
                var value = (dateValue.getMonth() + 1).toString().padLeft(2, '0') + '/' + dateValue.getDate().toString().padLeft(2, '0') + '/' + dateValue.getFullYear();
                var data = { 'CalculationDate': value };

                skyward.window.checkLoadContent('immunizationPlaceholder', 'Health', 'StudentVaccinationYear', 'GetAnnualImmunizationStatusLoader', null, data);
            });

            var printButton = tableContainer.find('#PrintButton');
            printButton.on("click", function ()
            {
                var url = skyward.global.virtualDir + "Health/StudentVaccinationYear/PrintAnnualImmunizationStatus";
                skyward.printScreen.launchWorkflow(url, {});
            });
        };

        //Maintain Student Vaccines
        var loadMaintainStudentVaccines = function()
        {
            const datepickerClassname = '.studentvaccine-datepicker';

            $(datepickerClassname).each(function ()
            {
                $(this).on('change', function()
                {
                    $(this).val() ? $(this).addClass('bold') : $(this).removeClass('bold');
                });

                if ($(this).val())
                {
                    $(this).addClass('bold');
                }
            });
        };

        //Hearing Screening
        var loadHearingScreeningTable = function ()
        {
            var tableContainer = $(this);
            var cutoffDateForPreviousYearLateExam = tableContainer.find('#CutoffDateForPreviousYearLateExam');

            var printButton = tableContainer.find('#PrintButton');
            var showTotalsButton = tableContainer.find('#ShowTotalsButton');

            printButton.on("click", function ()
            {
                var url = skyward.global.virtualDir + "Health/HearingScreening/PrintHearingScreening";
                skyward.printScreen.launchWorkflow(url, {});
            });

            showTotalsButton.on("click", function ()
            {
                var dateValue = skyward.controls.getValue(cutoffDateForPreviousYearLateExam);
                var value = (dateValue.getMonth() + 1).toString().padLeft(2, '0') + '/' + dateValue.getDate().toString().padLeft(2, '0') + '/' + dateValue.getFullYear();
                var data = { 'cutoffDateForPreviousYearLateExam': value, 'skipCalculatingTotals': false };

                skyward.window.checkLoadContent('hearingScreeningPlaceholder', 'Health', 'HearingScreening', 'GetHearingScreeningLoader', null, data);
            });
        };

        //AN Screening
        var loadAcanthosisNigricansScreeningTable = function ()
        {
            var tableContainer = $(this);
            var asOfDateForTotals = tableContainer.find('#AsOfDateForANTotals');

            var printButton = tableContainer.find('#PrintButton');
            var showTotalsButton = tableContainer.find('#ShowTotalsButton');

            printButton.on("click", function ()
            {
                var url = skyward.global.virtualDir + "Health/PhysicalScreening/PrintAcanthosisNigricansTotals";
                skyward.printScreen.launchWorkflow(url, {});
            });

            showTotalsButton.on("click", function ()
            {
                var dateValue = skyward.controls.getValue(asOfDateForTotals);
                var value = (dateValue.getMonth() + 1).toString().padLeft(2, '0') + '/' + dateValue.getDate().toString().padLeft(2, '0') + '/' + dateValue.getFullYear();
                var data = { 'physicalScreeningANTableTXDate': value, 'skipCalculatingTotals': false };

                skyward.window.checkLoadContent('acanthosisNigricansPlaceholder', 'Health', 'PhysicalScreening', 'GetAcanthosisNigricansLoader', null, data);
            });
        };

        var loadVisionScreeningTable = function ()
        {
            var tableContainer = $(this);
            var cutoffDateForPreviousYearLateExam = tableContainer.find('#CutoffDateForPreviousYearLateExam');

            var printButton = tableContainer.find('#PrintButton');
            var showTotalsButton = tableContainer.find('#ShowTotalsButton');

            printButton.on("click", function ()
            {
                var url = skyward.global.virtualDir + "Health/VisionScreening/PrintVisionScreening";
                skyward.printScreen.launchWorkflow(url, {});
            });

            showTotalsButton.on("click", function ()
            {
                var dateValue = skyward.controls.getValue(cutoffDateForPreviousYearLateExam);
                var value = (dateValue.getMonth() + 1).toString().padLeft(2, '0') + '/' + dateValue.getDate().toString().padLeft(2, '0') + '/' + dateValue.getFullYear();
                var data = { 'cutoffDateForPreviousYearLateExam': value, "skipCalculatingTotals": false };

                skyward.window.checkLoadContent('visionScreeningPlaceholder', 'Health', 'VisionScreening', 'GetVisionScreeningLoader', null, data);
            });
        };

        //Scoliosis Screening
        var loadScoliosisScreeningTable = function ()
        {
            var tableContainer = $(this);
            var cutoffDateForPreviousYearLateExam = tableContainer.find('#CutoffDateForPreviousYearLateExam');

            var ageGenderSelector = tableContainer.find('#AgeGradeCode');

            var printButton = tableContainer.find('#PrintButton');
            var showTotalsButton = tableContainer.find('#ShowTotalsButton');

            printButton.on("click", function ()
            {
                var url = skyward.global.virtualDir + "Health/ScoliosisScreening/PrintScoliosisScreening";
                skyward.printScreen.launchWorkflow(url, {});
            });

            showTotalsButton.on("click", function ()
            {
                var dateValue = skyward.controls.getValue(cutoffDateForPreviousYearLateExam);
                var value = (dateValue.getMonth() + 1).toString().padLeft(2, '0') + '/' + dateValue.getDate().toString().padLeft(2, '0') + '/' + dateValue.getFullYear();
                var data = { 'cutoffDateForPreviousYearLateExam': value, "skipCalculatingTotals": false, 'ageGradeCode': skyward.controls.getValue(ageGenderSelector) };

                skyward.window.checkLoadContent('scoliosisScreeningPlaceholder', 'Health', 'ScoliosisScreening', 'GetScoliosisScreeningLoader', null, data);
            });
        };

        var init = function (selector)
        {
            //Student Profile Health Provider Information
            if ($(selector).find('.studentProfileHealthProviderInformation').length > 0)
            {
                var parent = $(selector).find(".studentProfileHealthProviderInformation");

                $(parent).find('.StudentsHealthProviderInformation').on('change', skyward.health.getContactInformation);
            }

            //Scheduled Medication Quick Entry
            if ($(selector).find('.administrationDateSelector').length > 0)
            {
                var datePicker = $(selector).find(".administrationDateSelector");

                datePicker.on('change', skyward.health.scheduledMedicationQuickEntryDate);
            }

            if ($(selector).find('.checkAllAdministerMedication').length > 0)
            {
                var checkAll = $(selector).find(".checkAllAdministerMedication");

                checkAll.on('change', skyward.health.scheduledMedicationQuickEntryCheckAll);
            }

            if ($(selector).find('.checkIndividualAdministerMedication').length > 0)
            {
                var checkIndividual = $(selector).find(".checkIndividualAdministerMedication");

                checkIndividual.on('change', skyward.health.scheduledMedicationQuickEntryCheckIndividual);
            }

            //Scheduled Procedure Quick Entry
            if ($(selector).find('.checkAllPerformProcedure').length > 0)
            {
                var checkAllPerformProcedure = $(selector).find(".checkAllPerformProcedure");

                checkAllPerformProcedure.on('change', skyward.health.scheduledProcedureQuickEntryCheckAll);
            }

            if ($(selector).find('.occurrenceDateSelector').length > 0)
            {
                var occurrenceDatePicker = $(selector).find(".occurrenceDateSelector");

                occurrenceDatePicker.on('change', skyward.health.scheduledProcedureQuickEntryOccurrenceDate);
            }

            $(selector).find('[id^="editTempNameProcedureScheduleDay_IsActive-"]').off('click', skyward.health.TempScheduleDayIsActiveSetReadOnly).on('click', skyward.health.TempScheduleDayIsActiveSetReadOnly);
            $(selector).find('[id^="editTempNameProcedureScheduleDay_IsActive-"]').each(skyward.health.TempScheduleDayIsActiveSetReadOnly);
            $(selector).find('[id^="editTempNameProcedureScheduleDay_UseScheduledStartTimeOverride-"]').off('click', skyward.health.TempScheduleDayUseStartTimeOverrideSetReadOnly).on('click', skyward.health.TempScheduleDayUseStartTimeOverrideSetReadOnly);
            $(selector).find('[id^="editTempNameProcedureScheduleDay_UseScheduledStartTimeOverride-"]').each(skyward.health.TempScheduleDayUseStartTimeOverrideSetReadOnly);
            $(selector).find('[id^="editTempNameProcedureScheduleDay_UseNamePerformedByOverride-"]').off('click', skyward.health.TempScheduleDayUseNameScheduledOverrideSetReadOnly).on('click', skyward.health.TempScheduleDayUseNameScheduledOverrideSetReadOnly);
            $(selector).find('[id^="editTempNameProcedureScheduleDay_UseNamePerformedByOverride-"]').each(skyward.health.TempScheduleDayUseNameScheduledOverrideSetReadOnly);

            $(selector).find('[id^="IsActive-"]').off('click', skyward.health.TempNameMedicationScheduleDayIsActiveSetReadOnly).on('click', skyward.health.TempNameMedicationScheduleDayIsActiveSetReadOnly);
            $(selector).find('[id^="IsActive-"]').each(skyward.health.TempNameMedicationScheduleDayIsActiveSetReadOnly);
            $(selector).find('[id^="UseScheduledAdministrationTimeOverride-"]').off('click', skyward.health.TempNameMedicationUseScheduledAdministrationTimeOverrideSetReadOnly).on('click', skyward.health.TempNameMedicationUseScheduledAdministrationTimeOverrideSetReadOnly);
            $(selector).find('[id^="UseScheduledAdministrationTimeOverride-"]').each(skyward.health.TempNameMedicationUseScheduledAdministrationTimeOverrideSetReadOnly);
            $(selector).find('[id^="UseNameAdministeredByOverride-"]').off('click', skyward.health.TempNameMedicationUseNameScheduledOverrideSetReadOnly).on('click', skyward.health.TempNameMedicationUseNameScheduledOverrideSetReadOnly);
            $(selector).find('[id^="UseNameAdministeredByOverride-"]').each(skyward.health.TempNameMedicationUseNameScheduledOverrideSetReadOnly);
        };

        skyward.health.TempScheduleDayIsActiveSetReadOnly = function ()
        {
            var isActive = $(this);
            var isActiveChecked = isActive.is(':checked');
            var tempNameProcedureScheduleDayID = isActive.attr("id").split("-")[1];
            var useScheduledStartTimeOverride = $("#editTempNameProcedureScheduleDay_UseScheduledStartTimeOverride-" + tempNameProcedureScheduleDayID);
            var scheduledStartTimeOverride = $("#editTempNameProcedureScheduleDay_ScheduledStartTimeOverride-" + tempNameProcedureScheduleDayID);
            var useNamePerformedByOverride = $("#editTempNameProcedureScheduleDay_UseNamePerformedByOverride-" + tempNameProcedureScheduleDayID);
            var nameIDPerformedByOverride = $("#editTempNameProcedureScheduleDay_NameIDPerformedByOverride-" + tempNameProcedureScheduleDayID);
            var nameIDPerformedByOverrideValue = nameIDPerformedByOverride.find('.codeEELValue').get(0);

            if (!isActiveChecked)
            {
                skyward.controls.setValue(useScheduledStartTimeOverride, false);
                skyward.controls.disable(useScheduledStartTimeOverride);
                skyward.controls.clearValue(scheduledStartTimeOverride);
                skyward.controls.disable(scheduledStartTimeOverride);
                skyward.controls.setValue(useNamePerformedByOverride, false);
                skyward.controls.disable(useNamePerformedByOverride);
                skyward.controls.clearValue(nameIDPerformedByOverride);
                skyward.controls.disable(nameIDPerformedByOverrideValue);
            }
            else
            {
                skyward.controls.enable(useScheduledStartTimeOverride);
                skyward.controls.enable(useNamePerformedByOverride);
            }
        };

        skyward.health.TempScheduleDayUseStartTimeOverrideSetReadOnly = function ()
        {
            var useStartTimeOverride = $(this);
            var useStartTimeOverrideChecked = useStartTimeOverride.is(':checked');
            var tempNameProcedureScheduleDayID = useStartTimeOverride.attr("id").split("-")[1];
            var scheduledStartTimeOverride = $("#editTempNameProcedureScheduleDay_ScheduledStartTimeOverride-" + tempNameProcedureScheduleDayID);

            if (!useStartTimeOverrideChecked)
            {
                skyward.controls.clearValue(scheduledStartTimeOverride);
                skyward.controls.disable(scheduledStartTimeOverride);
            }
            else
            {
                skyward.controls.enable(scheduledStartTimeOverride);
            }
        };

        skyward.health.TempScheduleDayUseNameScheduledOverrideSetReadOnly = function ()
        {
            var useNamePerformedByOverride = $(this);
            var useNamePerformedByOverrideChecked = useNamePerformedByOverride.is(':checked');
            var tempNameProcedureScheduleDayID = useNamePerformedByOverride.attr("id").split("-")[1];
            var nameIDPerformedByOverride = $("#editTempNameProcedureScheduleDay_NameIDPerformedByOverride-" + tempNameProcedureScheduleDayID);
            var nameIDPerformedByOverrideValue = nameIDPerformedByOverride.find('.codeEELValue').get(0);

            if (!useNamePerformedByOverrideChecked)
            {
                skyward.controls.clearValue(nameIDPerformedByOverride);
                skyward.controls.disable(nameIDPerformedByOverrideValue);
            }
            else
            {
                skyward.controls.enable(nameIDPerformedByOverrideValue);
            }
        };


        skyward.health.TempNameMedicationScheduleDayIsActiveSetReadOnly = function ()
        {
            var isActive = $(this);
            var isActiveChecked = isActive.is(':checked');
            var tempNameMedicationScheduleDayID = isActive.attr("id").split("-")[1];
            var useScheduledAdministrationTimeOverride = $("#UseScheduledAdministrationTimeOverride-" + tempNameMedicationScheduleDayID);
            var scheduledAdministrationTimeOverride = $("#ScheduledAdministrationTimeOverride-" + tempNameMedicationScheduleDayID);
            var useNameAdministeredByOverride = $("#UseNameAdministeredByOverride-" + tempNameMedicationScheduleDayID);
            var nameIDAdministeredByOverride = $("#NameIDAdministeredByOverride-" + tempNameMedicationScheduleDayID);
            var nameIDAdministeredByOverrideValue = nameIDAdministeredByOverride.find('.codeEELValue').get(0);

            if (!isActiveChecked)
            {
                skyward.controls.setValue(useScheduledAdministrationTimeOverride, false);
                skyward.controls.disable(useScheduledAdministrationTimeOverride);
                skyward.controls.clearValue(scheduledAdministrationTimeOverride);
                skyward.controls.disable(scheduledAdministrationTimeOverride);
                skyward.controls.setValue(useNameAdministeredByOverride, false);
                skyward.controls.disable(useNameAdministeredByOverride);
                skyward.controls.clearValue(nameIDAdministeredByOverride);
                skyward.controls.disable(nameIDAdministeredByOverrideValue);
            }
            else
            {
                skyward.controls.enable(useScheduledAdministrationTimeOverride);
                skyward.controls.enable(useNameAdministeredByOverride);
            }
        };

        skyward.health.TempNameMedicationUseScheduledAdministrationTimeOverrideSetReadOnly = function ()
        {
            var useScheduledAdministrationTimeOverride = $(this);
            var useScheduledAdministrationTimeOverrideChecked = useScheduledAdministrationTimeOverride.is(':checked');
            var tempNameMedicationScheduleDayID = useScheduledAdministrationTimeOverride.attr("id").split("-")[1];
            var scheduledAdministrationTimeOverride = $("#ScheduledAdministrationTimeOverride-" + tempNameMedicationScheduleDayID);

            if (!useScheduledAdministrationTimeOverrideChecked)
            {
                skyward.controls.clearValue(scheduledAdministrationTimeOverride);
                skyward.controls.disable(scheduledAdministrationTimeOverride);
            }
            else
            {
                skyward.controls.enable(scheduledAdministrationTimeOverride);
            }
        };

        skyward.health.TempNameMedicationUseNameScheduledOverrideSetReadOnly = function ()
        {
            var useNameAdministeredByOverride = $(this);
            var useNameAdministeredByOverrideChecked = useNameAdministeredByOverride.is(':checked');
            var tempNameMedicationScheduleDayID = useNameAdministeredByOverride.attr("id").split("-")[1];
            var nameIDAdministeredByOverride = $("#NameIDAdministeredByOverride-" + tempNameMedicationScheduleDayID);
            var nameIDAdministeredByOverrideValue = nameIDAdministeredByOverride.find('.codeEELValue').get(0);

            if (!useNameAdministeredByOverrideChecked)
            {
                skyward.controls.clearValue(nameIDAdministeredByOverride);
                skyward.controls.disable(nameIDAdministeredByOverrideValue);
            }
            else
            {
                skyward.controls.enable(nameIDAdministeredByOverrideValue);
            }
        };


        skyward.health.getContactInformation = function ()
        {
            var clickedProvider = $(this);
            var parentWrapper = clickedProvider.parents('.studentProfileHealthProviderInformation');

            var primaryKey = skyward.controls.getValue(clickedProvider);
            var controlFiredFrom = clickedProvider.attr("name");

            $.ajax({
                url: skyward.global.virtualDir + "Student/EmergencyContact/GetHealthProfessionalAndBusinessContactInformation",
                type: "POST",
                dataType: "JSON",
                data: { primaryKey: primaryKey, controlFiredFromName: controlFiredFrom },
                success: function (data)
                {
                    var phoneUpdates = data.PhoneUpdate || {};
                    var emailUpdates = data.EmailUpdate || {};
                    var field;

                    for (field in phoneUpdates)
                    {
                        var nameElement = parentWrapper.find('.' + field);
                        skyward.controls.setValue(nameElement, phoneUpdates[field]);
                    }
                    for (field in emailUpdates)
                    {
                        var nameElement = parentWrapper.find('.' + field);
                        if (emailUpdates[field] == '')
                        {
                            nameElement.hide();
                        }
                        else
                        {
                            nameElement.show();
                        }
                        nameElement.attr('href', 'mailto:' + emailUpdates[field]);
                        nameElement.find('span.anchorText').html(emailUpdates[field]);
                    }
                }
            })
        };

        skyward.health.scheduledMedicationQuickEntryDate = function ()
        {
            var datePicker = $(this);
            var data =
            {
                "AdministrationDate": datePicker[0].value.split(' ')[0]
            };

            skyward.window.loadContent("moduleContent", "Health", "NameMedication", "ScheduledMedicationQuickEntry", null, data);
        };

        skyward.health.scheduledMedicationQuickEntryCheckAll = function ()
        {
            var checkAll = $(this);
            $('[id$="-AdministerMedication"]').each(function ()
            {
                var checkbox = $(this);
                if ((checkAll.is(':checked') && !checkbox.is(':checked')) || (!checkAll.is(':checked') && checkbox.is(':checked')))
                {
                    checkbox.click();
                }
            });
        };

        skyward.health.scheduledMedicationQuickEntryCheckIndividual = function ()
        {
            var checkbox = $(this);
            if (!checkbox.is(':checked'))
            {
                var id = checkbox[0].id.toString().split('-AdministerMedication')[0];
                var date = $('#' + id + '-AdministrationDate');
                var time = $('#' + id + '-AdministrationTime');

                date[0].placeholder = "MM/DD/YYYY";
                date[0].value = null;
                time[0].value = null;
            }
        };

        skyward.health.showPOLBannerWorkflow = function(context)
        {
            skyward.controls.hide($('#MessageArea'));
            var currentState = $('#StateCode').val();

            if (currentState !== "WA")
            {
                return;
            }

            context.find('#StudentChildhoodIllnessChildhoodIllnessID').on('eelComplete', function ()
            {
                var childhoodIllnessCode = $('#StudentChildhoodIllnessChildhoodIllnessID_code').val();

                if (childhoodIllnessCode !== undefined)
                {
                    var messageArea = $('#MessageArea');

                    if (childhoodIllnessCode === "POL")
                    {
                        skyward.controls.show(messageArea);
                    }
                    else
                    {
                        skyward.controls.hide(messageArea);
                    }
                }
            });
        };

        //Scheduled Procedure Quick Entry
        skyward.health.scheduledProcedureQuickEntryOccurrenceDate = function ()
        {
            var datePicker = $(this);
            var data =
            {
                "OccurrenceDate": datePicker[0].value.split(' ')[0]
            };

            skyward.window.loadContent("moduleContent", "Health", "NameProcedureOccurrence", "ScheduledProcedureQuickEntry", null, data);
        };

        skyward.health.scheduledProcedureQuickEntryCheckAll = function ()
        {
            var checkAll = $(this);
            $('[id$="-PerformProcedure"]').each(function ()
            {
                var checkbox = $(this);
                if ((checkAll.is(':checked') && !checkbox.is(':checked')) || (!checkAll.is(':checked') && checkbox.is(':checked')))
                {
                    checkbox.click();
                }
            });
        };

        skyward.health.officeVisitClickAction = function ()
        {
            var button = $(this);

            var buttonData = button.data();
            var workflowData =
            {
                "NameID": buttonData.nameid,
                "Status": buttonData.status,
                "EntityID": buttonData.entityid,
                "SchoolYearID": buttonData.schoolyearid,
                "InitializeHash": buttonData.initializehash
            };

            skyward.controls.disable(button);
            button.off("click");
            skyward.window.loadContent("full", "Health", "NameOfficeVisit", "Initialize", null, workflowData);
        };

        skyward.events.registerEvents("health",
            {
                "loadAnnualImmunizationStatusTable": loadAnnualImmunizationStatusTable,
                "loadMaintainStudentVaccines": loadMaintainStudentVaccines,
                "loadHearingScreeningTable": loadHearingScreeningTable,
                "loadAcanthosisNigricansScreeningTable": loadAcanthosisNigricansScreeningTable,
                "loadVisionScreeningTable": loadVisionScreeningTable,
                "loadScoliosisScreeningTable": loadScoliosisScreeningTable,
                "officeVisitClickAction": skyward.health.officeVisitClickAction,
                "showPOLBannerWorkflow": skyward.health.showPOLBannerWorkflow
            });

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
